import React from 'react';
import PropTypes from 'prop-types';
import './ButtonBar.scss';
import {
  Divider
} from '../../../modules/brochure/components/StyledComponents/StyledComponents';

const ButtonBar = ({ includeDivider = false, children }) => {
  //children = createFragment(children);
  return (
    <>
      {
        includeDivider && <Divider />
      }
      <div className="button-bar">
        {children}
      </div>
    </>
  );
};

ButtonBar.propTypes = {
  children: PropTypes.node,
};

export default ButtonBar;
